let systemAudioPlaybackMs = 0;
let lastPlayingTickAt: number | null = null;

export function resetSignalPathSession(): void {
  systemAudioPlaybackMs = 0;
  lastPlayingTickAt = null;
}

export function recordSignalPathPlaybackTick(
  isSystemAudio: boolean,
  isPlaying: boolean,
  nowMs = Date.now(),
): void {
  if (!isSystemAudio || !isPlaying) {
    lastPlayingTickAt = null;
    return;
  }
  if (lastPlayingTickAt != null) {
    systemAudioPlaybackMs += Math.max(0, nowMs - lastPlayingTickAt);
  }
  lastPlayingTickAt = nowMs;
}

export function getSystemAudioPlaybackMs(): number {
  return systemAudioPlaybackMs;
}

/** Test helper — inject accumulated session playback time. */
export function setSystemAudioPlaybackMsForTest(ms: number): void {
  systemAudioPlaybackMs = ms;
  lastPlayingTickAt = null;
}
